/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider, MuiThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, TextField, Grid, Button, Link, IconButton, Tooltip } from '@material-ui/core'

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FileCopy from '@material-ui/icons/FileCopy';
import lightBlue from '@material-ui/core/colors/lightBlue';

import { SalesforceConfig, ServicenowConfig } from '../TicketConfig.js';
import PDFConfig from '../PDFConfig.js';

import TicketResult from './TicketResult.js';
const styles = theme => ({
    text_field : {
        width : '30%',
    },

    title: {
        fontSize: 14,
      },
      pos: {
        marginBottom: 12,
      },

      divider: {
          margin: "8px 0px"
      },

      modules: {
          marginRight: "12px",
          
      }
})

const blueTheme = createMuiTheme({ 
    palette: { 
        primary: {
            main: lightBlue[600]
        } 
    },
    typography: {
        useNextVariants: true,
        h6: {
            fontSize: '0.95rem',
            lineHeight: 1.3
        },
        body2Next: {
            fontSize: "0.75rem"
        }
    }
})

const commands = ['--eval', '--path']

class RecoResultItem extends Component {
    state = {
        
    }
  

    componentWillMount(){

    }


    getLabelsAndValues = ( resultObj, compareDisplayObj ) => {
     
        let isCompareObjArr = Array.isArray(compareDisplayObj)
        if(isCompareObjArr){
            let evaluatedArr = [];
            compareDisplayObj.map((element) => {
                let evalObj = this.getEvaluatedObj(resultObj, element)
                evaluatedArr.push(evalObj)     
            })

            evaluatedArr = evaluatedArr.filter(function( element ) {
                return element !== undefined;
            });

            return evaluatedArr
          
        } else {
         
            let evaluated = this.getEvaluatedObj( resultObj, compareDisplayObj)
            return evaluated
        } 
        
       
    }


    getEvaluatedObj = ( obj, compareDisplayObj ) => {
        let evaluatedObj;
        let isNameEqual = false;
        let evaluatedResult ;
        let isResultArray = Array.isArray(obj);

        if(isResultArray){
            for( let i = 0; i < obj.length;  i++ ){
                console.log("index")
                console.log(obj[i])
                evaluatedResult = this.getEvaluatedResult(obj[i], compareDisplayObj);
                if(evaluatedResult !== undefined){
                    evaluatedObj = evaluatedResult;
                    isNameEqual = true;
                }

                if(isNameEqual == true){
                    break;
                }
            }
        } else {
            evaluatedObj = this.getEvaluatedResult(obj, compareDisplayObj);
        }
       
        return evaluatedObj;
        
    }


    getEvaluatedResult = ( obj, compareDisplayObj ) => {
        let evaluatedResult;

      {/*  let resultKeys = Object.keys(obj);
        let resultValues = Object.values(obj);


        for( let i = 0; i < resultKeys.length ; i++){
            if(typeof resultValues[i] === 'object'){
                return this.getEvaluatedResult(resultValues[i], compareDisplayObj)
            } else {
                if( obj.name === compareDisplayObj.name){
                    //let val = obj.value;
                    let val = this.getValue(obj.value)
                    evaluatedResult =  { value : val, label: compareDisplayObj.label}
                    break;
                }
            }
        }  */}
        
        if(obj.name === compareDisplayObj.name){
            let val = this.getValue(obj.value)
            evaluatedResult =  { value : val, label: compareDisplayObj.label}
        }
        
        return evaluatedResult;
    }
    getValue = ( val ) => {
        let objValues = Object.values(val)
        let value = objValues.filter((element) => element != null || element != undefined)
                        .reduce(function(acc, element){
                            return element;
                    })
        return value;
    }

   

    renderCardHeader = () => {
        
        const { type } = this.props;
        let evaluatedObj;


     
        if(type == 'ticket' || type == 'sm' || type == 'csv'){
            return  this.renderTicketSummary()
        } else if( type == 'pdf'){
           return this.renderPDFSummary()
        }

    

       
    
    }

    renderCardContent = () => {
        let { config } = this.props;
        let { issue } = config.displayLabels;
        let { result } = config;
        let objToCompare = result.iu_record_world_view.wv_field_list;
        let evaluatedObj = this.getLabelsAndValues(objToCompare, issue );
      
      
        let description = evaluatedObj.filter((i) => i.label == 'Description')
        
        return (
            <Fragment key={description}>
                
                <Typography variant='body2' dangerouslySetInnerHTML={{__html: description.value}}></Typography>
            
            </Fragment>
        )
       
    }


    renderTicketSummary = () => {
        let { config } = this.props;
        let { result } = config;
        
        let displayLabels = SalesforceConfig.displayLabels;
        
        
     {/*   let iuType = result.iu_record_world_view.wv_id_str.IU_key.user_friendly_name;
        if( iuType == 'salesforce'){
            displayLabels = SalesforceConfig.displayLabels;
        } else if( iuType == 'servicenow') {
            displayLabels = ServicenowConfig.displayLabels;
        } */}

    
       
        
        
        let objToCompare = result.wv_field_list;
        let { identifier } = displayLabels;
        let evaluatedObj = this.getLabelsAndValues(objToCompare, identifier );

        return (
            <CardHeader
                        aria-label={ evaluatedObj.label }
                        titleTypographyProps = {{
                            variant: 'overline',
                            color: ( this.props.selectedResult == this.props.index ? '#fff' : "#000" )
                        }}
                        subheaderTypographyProps = {{
                            variant: 'h6',
                            color: 'primary',
                            tabIndex : 0
                        }}
                        title = { evaluatedObj.label }
                        subheader = {
                            <Typography> {evaluatedObj.value} </Typography>
                        }
                    ></CardHeader>
        )

    }

    renderPDFSummary = () => {
        let { config } = this.props;
        let { identifier } = PDFConfig.displayLabels;
        let { result } = config;
        let objToCompare = result.wv_field_list;
       // let evaluatedObj = this.getLabelsAndValues(objToCompare, identifier );
        let iu_src_info = result.iu_record_src_info.iu_record_nav_info.source[0].link
        return (
           <Fragment>
                <CardHeader
                            aria-label={ iu_src_info }
                            titleTypographyProps = {{
                                variant: 'overline',
                                color: ( this.props.selectedResult == this.props.index ? '#fff' : "#000" )
                            }}
                            subheaderTypographyProps = {{
                                variant: 'h6',
                                color: 'primary',
                                tabIndex : 0
                            }}
                            title = { iu_src_info }
                            
                ></CardHeader>
                <CardActions>

                </CardActions>
            </Fragment>
                    
                  
        )
    }

    getRelevantPages = ( result ) => {

    }
   
    render() {
        const { classes, type, index } = this.props;
        const { result } = this.props.config;
        return ( 
            <MuiThemeProvider theme={blueTheme}>
                <Card elevation = {3} square 
                    style = {{ 
                       // width : '100%', 
                      //  height : 'auto', 
                      //  padding: '8px', 
                       // marginBottom: "8px",

                        width: '98%',
                        padding: '8px',
                        margin:'0.5%',
                        marginBottom: '10px',
                        boxSizing: 'border-box',
                        background: ( this.props.selectedResultItem == this.props.index ? '#009dd4' : "#fff" ),
                        color: ( this.props.selectedResultItem == this.props.index ? '#fff' : "#000" ),
                        cursor: 'pointer',
                        maxHeight: "120px",
                        overflow: "auto"
                    }}   
                    onClick = {(event) => {
                        event.preventDefault();
                        this.props.updateDetailViewer(result, index); 
                    }}>
                        
                        

                            
                    {
                        this.renderCardHeader()
                    }
                   
                    {/* {
                        this.renderCardContent()
                    } */}
                    {
                        this.props.type == 'recommendation' && (
                            <CardActions>
                               
                            </CardActions>
                        )
                    }
                    
                </Card>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(styles)(RecoResultItem);